import React from "react";
import { Route, Routes } from "react-router-dom";
import DashboardScope3 from "../Pages/Scope3/Dashboard/Overview";
import PurchaseGoodsDashboard from "../Pages/Scope3/Dashboard/PurchaseGoods";
import EmployeeCommuteDashboard from "../Pages/Scope3/Dashboard/EmployeeCommute";
import TransportationDashboard from "../Pages/Scope3/Dashboard/Transportation";
import RailTransport from "../Pages/Scope3/TransportationDistribution/Rail";
import ShipTransport from "../Pages/Scope3/TransportationDistribution/Ship";
import Emissions from "../Pages/Scope3/PurchasedGoods&Services/Emissions/Emissions";
import BusinessTravel from "../Pages/Scope3/BusinessTravel";
import FuelEnergy from "../Pages/Scope3/FuelEnergyActivities";
import UseOfSoldProductsPage from "../Pages/Scope3/UseOfSoldProducts";
import FranchisesPage from "../Pages/Scope3/Franchises";
import InvestmentsPage from "../Pages/Scope3/Investments";
import UpstreamLeasedAssetsPage from "../Pages/Scope3/UpstreamLeasedAssets";
import WasteGenerated from "../Pages/Scope3/WasteGenerated";
import EmployeeCommute from "../Pages/Scope3/EmployeeCommute";
import BusinessTravelDashboard from "../Pages/Scope3/Dashboard/BusinessTravel";
import WasteGeneratedDashboard from "../Pages/Scope3/Dashboard/WasteGenerated";
import CapitalGoodsDashboard from "../Pages/Scope3/Dashboard/CapitalGoods";
import Road from "../Pages/Scope3/TransportationDistribution/Road";
import AirTransportation from "../Pages/Scope3/TransportationDistribution/Air";
import CO2EmissionEstimator from "../Pages/Scope3/TransportationDistribution/CO2EmissionCalculator";
import WaterMangementMain from "../Pages/Scope3/WaterManagement/WaterManagementMain";
import CapitalGoods from "../Pages/Scope3/CapitalGoods";
import ProcessingOfSoldProducts from "../Pages/Scope3/ProcessingOfSoldProducts";
import ProcessingOfSoldProductsDashboard from "../Pages/Scope3/Dashboard/ProcessingOfSoldProducts";
import DownstreamLeasedAssets from "../Pages/Scope3/DownstreamLeasedAssets";
import DownstreamLeasedAssetsDashboard from "../Pages/Scope3/Dashboard/DownstreamLeasedAssets";
import UpstreamLeasedAssetsDashboard from "../Pages/Scope3/Dashboard/UpstreamLeasedAssets";
import EOLTreatmentOfSoldProductsPage from "../Pages/Scope3/EOLTreatmentOfSoldProducts";
import FranchisesDashboard from "../Pages/Scope3/Dashboard/Franchises/index";
import InvestmentsDashboard from "../Pages/Scope3/Dashboard/Investments";
import UseOfSoldProductsDashboard from "../Pages/Scope3/Dashboard/UseOfSoldProducts";
import EOLTreatmentOfSoldProductsDashboard from "../Pages/Scope3/Dashboard/EOLTreatmentOfSoldProducts";

export const Scope3Routes = [
  {
    path: "/scope3/transportation/dashboard",
    element: <TransportationDashboard />,
  },
  { path: "/scope3/transportation/road", element: <Road /> },
  {
    path: "/scope3/transportation/air",
    element: <AirTransportation />,
  },
  {
    path: "/scope3/CO2EmissionEstimator",
    element: <CO2EmissionEstimator />,
  },
  {
    path: "/scope3/purchased-goods/dashboard",
    element: <PurchaseGoodsDashboard />,
  },
  { path: "/scope3/purchased-goods/emissions", element: <Emissions /> },
  { path: "/scope3/transportation/rail", element: <RailTransport /> },
  { path: "/scope3/transportation/ship", element: <ShipTransport /> },
  {
    path: "/scope3/business-travel/emission",
    element: <BusinessTravel />,
  },
  // {
  //   path: "/scope3/fuel-energy-activities",
  //   element: <FuelEnergy />,
  // },
  {
    path: "/scope3/use-of-sold-products",
    element: <UseOfSoldProductsPage />,
  },
  {
    path: "/scope3/use-of-sold-products/dashboard",
    element: <UseOfSoldProductsDashboard />,
  },
  {
    path: "/scope3/eol-treatment-of-sold-products",
    element: <EOLTreatmentOfSoldProductsPage />,
  },
  {
    path: "/scope3/eol-treatment-of-sold-products/dashboard",
    element: <EOLTreatmentOfSoldProductsDashboard />,
  },
  {
    path: "/scope3/franchises",
    element: <FranchisesPage />,
  },
  {
    path: "/scope3/franchises/dashboard",
    element: <FranchisesDashboard />,
  },
  {
    path: "/scope3/investments",
    element: <InvestmentsPage />,
  },
  {
    path: "/scope3/investments/dashboard",
    element: <InvestmentsDashboard />,
  },
  {
    path: "/scope3/waste-generated/operation",
    element: <WasteGenerated />,
  },
  {
    path: "/scope3/waste-generated/dashboard",
    element: <WasteGeneratedDashboard />,
  },
  { path: "/water-management/data", element: <WaterMangementMain /> },
  { path: "/scope3/employee-commute", element: <EmployeeCommute /> },
  {
    path: "/scope3/employee-commute/dashboard",
    element: <EmployeeCommuteDashboard />,
  },
  {
    path: "/scope3/upstream-leased-assets",
    element: <UpstreamLeasedAssetsPage />,
  },
  {
    path: "/scope3/upstream-leased-assets/dashboard",
    element: <UpstreamLeasedAssetsDashboard />,
  },
  { path: "/scope3/dashboard", element: <DashboardScope3 /> },
  {
    path: "/scope3/business-travel/dashboard",
    element: <BusinessTravelDashboard />,
  },
  {
    path: "/scope3/capital-goods/emission",
    element: <CapitalGoods />,
  },
  {
    path: "/scope3/capital-goods/dashboard",
    element: <CapitalGoodsDashboard />,
  },
  {
    path: "/scope3/processing-of-sold-products",
    element: <ProcessingOfSoldProducts />,
  },
  {
    path: "/scope3/processing-of-sold-products/dashboard",
    element: <ProcessingOfSoldProductsDashboard />,
  },
  {
    path: "/scope3/downstream-leased-assets",
    element: <DownstreamLeasedAssets />,
  },
  {
    path: "/scope3/downstream-leased-assets/dashboard",
    element: <DownstreamLeasedAssetsDashboard />,
  },
];
